/* src/app/views/dashboard/components/sidebar-nav/sidebar-sub-item-list/sidebar-sub-item-list.component.scss */
.nav-sub-list {
  margin-left: 3rem;
  overflow-y: hidden;
}
/*# sourceMappingURL=sidebar-sub-item-list.component.css.map */
